import React, { createContext, useState } from "react";
import { data } from "./data";
import type { MainContextValue } from "./types";

interface MainContextProviderProps {
  children: React.ReactNode;
}

const MainContext = createContext<MainContextValue>({
  portfolio: [],
  activePortfolio: null,
  setActivePortfolio: () => {},
});

export const MainContextProvider = ({ children }: MainContextProviderProps) => {
  const [activePortfolio, setActivePortfolio] = useState<number | null>(null);

  const setActivePortfolioItem = (item: number | null): void => {
    setActivePortfolio(item);
  };

  return (
    <MainContext.Provider
      value={{
        portfolio: data,
        activePortfolio,
        setActivePortfolio: setActivePortfolioItem,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export default MainContext;
